<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('spareParts.exploded.title') }}
      </h2>

      <p>{{ $t('spareParts.exploded.description') }}</p>

      <div class="irinox-form after-sales" >
        <form @submit.prevent="onSubmit(!v$.form.$invalid)" class="">

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-lg-4 p-md-6">
                  <label for="title" >{{ $t('spareParts.exploded.doc_title') }}</label>
                  <InputText id="title" v-model="form.title" :placeholder="$t('spareParts.exploded.doc_title_ph')" 
                    :class="{'p-invalid':v$.form.title.$invalid && submitted}"/>
              </div>
              <div class="p-field p-col-12 p-lg-4 p-md-6">
                  <label for="domain">{{ $t('spareParts.exploded.domain') }}</label>
                  <Dropdown id="domain"
                      v-model="form.domain"
                      :options="domains"
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('spareParts.exploded.domain_ph')" 
                      :class="{'p-invalid':v$.form.domain.$invalid && submitted}" />
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <label>{{ $t('spareParts.exploded.machines_association') }}</label>
                <div v-if="form.docTreeIds.length>0"  class="p-my-3 p-d-flex p-ai-center p-flex-wrap selected-machines">
                  <div v-for="id in form.docTreeIds" :key="id" class="selected-machine p-grid-nogutter p-ai-center">
                    <div class="p-col-fixed" style="width: 100px; overflow: hidden;">
                      <img :src="$config.afterSalesAssets('models') + findLastLevel(id).key + '.svg'" :alt="'MODEL'" />
                    </div>
                    <div class="p-col">
                      <span>{{ findLastLevel(id).label }}</span>
                    </div>
                    <div class="p-col-fixed">
                      <i class="icon-trash" @click="removeMachine(id)"></i>
                    </div>
                  </div>
                </div>
                <div class="p-my-1">
                  <Button :disabled="!form.domain" class="p-button-secondary small-button" :label="$t('spareParts.exploded.machines_association_button')" :severity="v$.form.docTreeIds.$invalid && submitted ? 'danger' : ''"
                    @click="dialog.selectModel = true"/>
                </div>
              </div>
          </div>

          <div v-if="previousVersions?.length>0" class="existing-document">
            <i class="icon-alert"></i>
            <span>{{ $t('spareParts.exploded.existing_document') }}</span>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div :class="['p-field p-col-12 p-md-6', {'p-invalid':v$.form.pdf.$invalid && submitted}]" >
                  <label>{{ $t('spareParts.exploded.upload_pdf') }}</label>

                  <FileUpload
                    ref="uploaderPdf"
                    mode="advanced"
                    :multiple="false"
                    :customUpload="true"
                    :showUploadButton="false"
                    :showCancelButton="false"
                    :maxFileSize="100 * 1000 * 1000"
                    :chooseLabel="$t('spareParts.exploded.upload_pdf_choose')"
                    @select="onPdfSelect"
                    @remove="onPdfRemove"
                    @clear="onPdfClear"
                    :disabled="form.pdf.length > 0"
                  >

                    <template #empty>
                      <p>{{ $t('spareParts.exploded.upload_pdf_drag_and_drop') }}</p>
                    </template>
                  </FileUpload> 

              </div>
              <div :class="['p-field p-col-12 p-md-6', {'p-invalid':v$.form.excel.$invalid && submitted}]" >
                  <label>{{ $t('spareParts.exploded.upload_excel') }}</label>

                  <FileUpload
                    ref="uploaderExcel"
                    mode="advanced"
                    :multiple="false"
                    :customUpload="true"
                    :showUploadButton="false"
                    :showCancelButton="false"
                    :maxFileSize="20 * 1000 * 1000"
                    :chooseLabel="$t('spareParts.exploded.upload_excel_choose')"
                    @select="onExcelSelect"
                    @remove="onExcelRemove"
                    @clear="onExcelClear"
                    :disabled="form.excel.length > 0"
                  >

                    <template #empty>
                      <p>{{ $t('spareParts.exploded.upload_excel_drag_and_drop') }}</p>
                    </template>
                  </FileUpload> 

              </div>
          </div>


          <div class="p-fluid p-formgrid p-grid p-mt-4">
              <div class="p-d-flex p-col-12 p-md-6 p-lg-4">
                <Button type="submit" :label="previousVersions?.length>0 ? $t('spareParts.exploded.update_document') : $t('spareParts.exploded.save_document')" class="p-mr-2" />
                <!-- <Button type="button" :label="$t('spareParts.exploded.reset_form')" class="p-button-secondary" @click="resetForm" /> -->
              </div>
          </div>

        </form>
      </div>

    </div>
  </div>

  <Toast />

  <DocTreeSelect :visible="dialog.selectModel" :docTreeRaw="docTreeRaw" :docTreeIds="form.docTreeIds" :domain="form.domain"
    @update:visible="dialog.selectModel = $event" @update:docTreeIds="updateDocTreeIds"/>

  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.up_success" 
    mode="success" 
    :message="$t('spareParts.exploded.upload_doc_success')"
    :life="3000" 
    @update:visible="dialog.up_success = $event" />


</template>

<script>
// import { required, email, sameAs, minLength, maxLength, numeric, minValue, maxValue, requiredIf } from "@vuelidate/validators";
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from 'vuex';
import DocTreeSelect from '../DocTreeSelect.vue';
import AfterSalesService from '../../../service/AfterSalesService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';

export default {
  components: { 
    DocTreeSelect,
    IrinoxDialogDark
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      form: { 
        title: null, 
        domain: null, 
        docTreeIds: [],
        pdf: [],
        excel: [],
      },
      domains: [
        { label: this.$t('afterSales.domain_STANDARD'), value: 'STANDARD' },
        { label: this.$t('afterSales.domain_NORTH_AMERICA'), value: 'NORTH AMERICA' },
        // { label: this.$t('afterSales.domain_FMI_JAPAN'), value: 'FMI JAPAN' },
      ],
      submitted: false,
      previousVersions: [],
      dialog: {
        selectModel: false,
        error: false,
        up_success: false,
        dl_success: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      is24hour: 'userdata/is24hour',
    }),
    isKeySelected() {
      return this.form.title && this.form.domain && this.form.docTreeIds.length>0;
    },
  },
  validations() {
      return {
          form: {
            title: {
                required
            },
            domain: {
                required
            },
            docTreeIds: {
                required: requiredIf(function() {
                  return this.form.domain!=null
                }),
            },
            pdf: {
                required
            },
            excel: {
                required
            },
          }
      };
  },
  watch: {
    'form.domain': 'changeDomain',
    'form.title': 'checkKeySelection',
    'form.docTreeIds': 'checkKeySelection',
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() { 
    if(this.docTreeRaw.length===0) {
      this.$router.push('/after-sales');
    }
  },
  methods: {
    changeDomain() { 
      this.form.docTreeIds = [] 
    },
    checkKeySelection() {
      if(this.isKeySelected) {
        // this.afterSalesService.getPreviousVersions(this.personaltoken, this.form.domain, this.form.category, this.form.language, this.form.title, this.form.docTreeIds)
        //   .then((data) => {
        //     if(data.code=="200") {
        //       this.previousVersions = data.body.sort((a,b) => (a.version<b.version) ? 1 : ((b.version<a.version) ? -1 : 0));
        //     } else {
        //       console.error("ERROR " + JSON.stringify(data));
        //       this.dialog.error = true;
        //     }
        //   })
        //   .catch(error => {
        //     console.error("EXCEPTION " + error);
        //     this.dialog.error = true;
        //   });
      }
    },
    updateDocTreeIds(ids) {
      this.form.docTreeIds = ids;
    },
    getDocTreeById(id) {
      return this.docTreeRaw.find(node => node.docTreeId === id);
    },
    findLastLevel(id) {
      let docTree = this.getDocTreeById(id);
      if(docTree) {
        for(let i=5; i>=1; i--) {
          if(docTree['level'+i]) {
            return { key: docTree['level'+i], label: (docTree['level'+(i-1)+'Translation'] || docTree['level'+(i-1)]) + ' - ' + (docTree['level'+i+'Translation'] || docTree['level'+i]) };
          }
        }
      }
    },
    removeMachine(id) {
      this.form.docTreeIds = this.form.docTreeIds.filter(docTreeId => docTreeId !== id);
    },
    onPdfSelect(e) {
      this.form.pdf = [...e.files]
    },
    onPdfRemove(e) { 
      this.form.pdf = this.form.pdf.filter(f => f !== e.file) 
    },
    onPdfClear() { 
      this.form.pdf = [] 
    },
    onExcelSelect(e) {
      this.form.excel = [...e.files]
    },
    onExcelRemove(e) { 
      this.form.excel = this.form.excel.filter(f => f !== e.file) 
    },
    onExcelClear() { 
      this.form.excel = [] 
    },
    async onSubmit(isFormValid) {
      this.submitted = true;
      if (!isFormValid) {
        return;
      }
      let data = {
        title: this.form.title, 
        domain: this.form.domain, 
        docTreeIds: this.form.docTreeIds
      }
      this.afterSalesService.uploadSpDocs(this.personaltoken, data, this.form.pdf[0], this.form.excel[0])
        .then((data) => {
          if(data.code==="200") {
            this.dialog.up_success = true;
            this.resetFormPartially();
          } else {
            console.error("ERROR "+JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
          this.dialog.error = true;
        });
    },
    resetForm() {
      this.form = { 
        title: null, 
        domain: null, 
        docTreeIds: [],
        pdf: [],
      }
      this.submitted = false;
      this.previousVersions = [];
      this.$refs.uploaderPdf?.clear()
      this.$refs.uploaderExcel?.clear()
    },
    resetFormPartially() {
      this.form.title = null;
      this.form.pdf = [];
      this.submitted = false;
      this.previousVersions = [];
      this.$refs.uploaderPdf?.clear()
      this.$refs.uploaderExcel?.clear()
    },
  }
}
</script>